import Toast from '../../component/toastify/Index.jsx';
import axios from '../../axios/interceptor.js';

export const getCustomerStammdaten = async (payload) => {
    try {
        const response = await axios.post('/customer/stammdaten/getStammdaten', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const addCustomerStammdaten = async (payload) => {
    try {
        const response = await axios.post('/customer/stammdaten/createStammdaten', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const updateCustomerStammdaten = async (payload) => {

    try {
        const response = await axios.put(`/customer/stammdaten/updateStammdaten`, payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}


// document upload APIs

export const addStammdatenDucument = async (payload) => {
    try {
        const response = await axios.post(`/customer/stammdaten/addStammdatenDucument`, payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}


export const updateStammdatenDocument = async (id, payload) => {
    try {
        const response = await axios.put(`/customer/stammdaten/updateStammdatenDocument/${id}`, payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const deleteStammdatenDocument = async (id) => {
    try {
        const response = await axios.put(`/customer/stammdaten/deleteStammdatenDocument/${id}`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}